import { DOCUMENT } from '@angular/common'
import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { Subscription } from 'rxjs'

import { environment } from './../environments/environment'
import { OrderSubmittedEvent } from './models/quick-ticket.model'

@Component({
  selector: 'vmf-root',
  templateUrl: 'app.component.html',
  styles: [],
  providers: [],
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'Vanguard Investment Products Profile'
  public environment = environment
  initialLoadDone = false
  routerSubscription: Subscription

  constructor(
    private readonly router: Router,
    @Inject(DOCUMENT) private _document: Document,
  ) {
    if (
      !this._document?.defaultView?.customElements.get(
        'c11n-web-b5-youtube-player',
      )
    ) {
      const c11nYTP = this._document.createElement('script')
      c11nYTP.type = 'module'
      c11nYTP.src = 'https://cdn.web.vanguard.com/c11n-web/b5/youtube-player.js'
      c11nYTP.async = true
      this._document.body.appendChild(c11nYTP)
    }

    if (!this._document?.defaultView?.customElements.get('c11n-web-b5-icon')) {
      const c11nIcon = this._document.createElement('script')
      c11nIcon.type = 'module'
      c11nIcon.src = 'https://cdn.web.vanguard.com/c11n-web/b5/icon.js'
      c11nIcon.async = true
      this._document.body.appendChild(c11nIcon)
    }
  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && !this.initialLoadDone) {
        setTimeout(() => {
          this.ensureFragmentScroll()
        }, 0)
      }
    })
  }

  onOrderSubmitted(event: CustomEvent<OrderSubmittedEvent>): void {
    const order = event.detail
    console.log(
      `[Quick Ticket] orderSubmitted: confirmation ${order.confirmationNumber} for ${order.ticker}`,
    )
  }

  ensureFragmentScroll() {
    this.initialLoadDone = true
    const section = document.getElementById('Dashboard')
    if (section !== null && section !== undefined) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe()
  }
}
